import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {ISession, SESSION_DEFAULT} from "@/shared";
import {PublicKey} from "@solana/web3.js";

export const useSessionStore = defineStore("session", () => {
	// data
	const session = ref<ISession>(SESSION_DEFAULT);

	// methods
	function init(): void {
		const storage = localStorage.getItem("fluxbeam:v1:session");

		if (!storage) return;

		session.value = {
			...session.value,
			...JSON.parse(storage),
		};
	}

	function setLastToken(mint: string): void {
		try {
			new PublicKey(mint)
		} catch (e) {
			return
		}

		session.value.lastToken = mint
		update()
	}

	function update() {
		localStorage.setItem("fluxbeam:v1:session", JSON.stringify(session.value))
	}

	// setup
	init();

	// getter
	const getSession = computed<ISession>(() => session.value)
	const getLastToken = computed<string>(() => session.value.lastToken || "FLUXBmPhT3Fd1EDVFdg46YREqHBeNypn1h4EbnTzWERX")

	return {session, getSession, getLastToken, setLastToken};
});
